module.exports = __webpack_public_path__ + "static/media/9.47db4ca1.png";